function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { StyledIcons } from "./icons.scss";
import DefaultProps from "./default-props";
const Icons = (props)=>{
    const { icons } = props;
    return /*#__PURE__*/ _jsx(StyledIcons, {
        className: "icons",
        children: icons.map((icon, index)=>{
            return /*#__PURE__*/ _jsxs("div", {
                className: "icon-wrapper",
                children: [
                    /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, icon.image)),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "icon-texts-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "title",
                                children: /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                                    text: icon.title
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "subtitle",
                                children: /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                                    text: icon.subtitle
                                })
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
export default Icons;
Icons.defaultProps = DefaultProps;
